export default __webpack_public_path__ + "static/media/person-icon.f28d0fbc.svg";